module.exports = __webpack_public_path__ + "img/file-header.7fbdaf8d.png";